import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import ReactToggle from "react-toggle";
import "react-toggle/style.css";
import * as Yup from "yup";
import { Col, Row } from "reactstrap";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation } from "react-router-dom";

function AddEdit_CompanyMaster() {
  const API_URL = `${API_WEB_URLS.MASTER}/0/token/State`;
  const API_URL_SAVE = `CompanyMaster/0/token`;
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/CompanyMasterEdit/Id`;
  const navigate = useNavigate()
  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    formData: {},
    OtherDataScore: [],
    isProgress: true,
  });

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FillArray", `${API_URL}/Id/0`);

    const Id = location.state?.Id || 0;
    if (Id > 0) {
      setState(prevState => ({ ...prevState, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  const validationSchema = Yup.object({
    Name: Yup.string().required("Name is required"),
    Password: Yup.string().required("Password is required"),
    Address: Yup.string().required("Address is required"),
    IsActive: Yup.boolean().required("Active status is required"),
    GSTNo: Yup.string().notRequired(),
    FASSAINo: Yup.string().notRequired(),
    UDYAM: Yup.string().notRequired(),
    F_StateMaster: Yup.string().notRequired(),
    Phone1: Yup.string().notRequired(),
    Phone2: Yup.string().notRequired(),
  });

  const handleSubmit = async (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const formData = new FormData();
    formData.append("Name", values.Name);
    formData.append("Password", values.Password);
    formData.append("Address", values.Address);
    formData.append("IsActive", values.IsActive);
    formData.append("UserId", obj.uid);
    formData.append("GSTNo", values.GSTNo);
    formData.append("FASSAINo", values.FASSAINo);
    formData.append("UDYAM", values.UDYAM);
    formData.append("F_StateMaster", values.F_StateMaster);
    formData.append("Phone1", values.Phone1);
    formData.append("Phone2", values.Phone2);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid"
    );
  };

  return (
    <div className="page-content">
      <Formik
        initialValues={{
          ...state.formData,
          IsActive: state.formData.IsActive || false,
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values }) => (
          <Form className="form-horizontal">
            <Row>
              <Col lg="2">
                <label htmlFor="Name" className="form-label">Company Name</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="Name" />
                <ErrorMessage name="Name" component="div" className="text-danger" />
              </Col>
            </Row>
            <Row>
              <Col lg="2">
                <label htmlFor="Password" className="form-label">Password</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="Password" />
                <ErrorMessage name="Password" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2">
                <label htmlFor="Address" className="form-label">Address</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="Address" />
                <ErrorMessage name="Address" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2">
                <label htmlFor="GSTNo" className="form-label">GST No</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="GSTNo" />
                <ErrorMessage name="GSTNo" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2">
                <label htmlFor="FASSAINo" className="form-label">FSSAI No</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="FASSAINo" />
                <ErrorMessage name="FASSAINo" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2">
                <label htmlFor="UDYAM" className="form-label">UDYAM Reg No</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="UDYAM" />
                <ErrorMessage name="UDYAM" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2">
                <label htmlFor="F_StateMaster" className="form-label">State</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" as="select" name="F_StateMaster">
                  <option value="">Select State</option>
                  {state.FillArray.map(type => (
                    <option key={type.Id} value={type.Id}>{type.Name}</option>
                  ))}
                </Field>
                <ErrorMessage name="F_StateMaster" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2">
                <label htmlFor="Phone1" className="form-label">Phone 1</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="Phone1" />
                <ErrorMessage name="Phone1" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2">
                <label htmlFor="Phone2" className="form-label">Phone 2</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="Phone2" />
                <ErrorMessage name="Phone2" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2">
                <label htmlFor="IsActive" className="form-label">Active</label>
              </Col>
              <Col lg="2">
                <ReactToggle
                  checked={values.IsActive}
                  onChange={() => setFieldValue("IsActive", !values.IsActive)}
                />
                <ErrorMessage name="IsActive" component="div" className="text-danger" />
              </Col>
            </Row>

            <button type="submit" className="btn btn-primary btn-block">Submit</button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddEdit_CompanyMaster;
